import { Entity } from './entity';
import { ReadRequest, Request } from './request';
import { DataResponse, Response } from './response';

export enum FamilyTreeFields {
  AbEntryKey = 'AbEntryKey',
}

export interface FamilyTree extends Entity {
  [FamilyTreeFields.AbEntryKey]: string | null;
}

export interface FamilyTreeReadRequest extends Request {
  FamilyTreeRoots: ReadRequest<FamilyTree>;
}

export interface FamilyTreeResponse extends Response {
  FamilyTreeRoots: DataResponse<FamilyTree>;
}
